/**
 * Pre/postflow duration scaling for miller weld machine.
 *
 * Durations are held in tenths of a second, the same integer-with-0.1-resolution
 * convention the machine uses for voltage and travel speed.
 */
export const convertFlowTime = {
  /**
   * Convert a flow duration to weld machine format.
   * @param seconds Duration in seconds, in [0,3]
   * @returns Tenths of a second, in [0,30]
   */
  toWeldMachine: (seconds: number) => Math.round(seconds * 10),

  /**
   * Convert a flow duration from weld machine format.
   * @param received From machine, in tenths of a second
   * @returns Duration in seconds
   */
  fromWeldMachine: (received: number) => received / 10,
};
